import { format } from 'date-fns';
import Image from 'next/image';

import { PARTNERSHIPS_SVG_BASE_URL, TASK_ICONS_MAP } from '../utils';

import IconRounded from './IconRounded';
import Multiplier from './Multiplier';
import QuantaPoints from './QuantaPoints';
import CompletedMessage from './CompletedMessage';

interface TaskCardProps {
  missionId: number;
  title: string;
  points: number;
  maxMultiplier: number;
  multiplier: number;
  completionDate: string;
  icon: string;
}

const createOverlayContainer = (imageElement: React.ReactNode): React.ReactNode => {
  return (
    <div className='relative flex items-center justify-center shrink-0 bg-border-primary overflow-hidden'>
      {imageElement}
      <div className='absolute inset-0 bg-border-primary/50' />
    </div>
  );
};

const renderIcon = (icon: string, missionId: number): React.ReactNode => {
  if (TASK_ICONS_MAP[icon]) {
    return <IconRounded icon={TASK_ICONS_MAP[icon]} size={40} isOverlay={true} />;
  }

  if (missionId === 9) {
    return createOverlayContainer(<Image src={`${PARTNERSHIPS_SVG_BASE_URL}/${icon}.svg`} alt={icon} width={40} height={40} />);
  }

  // basically mission 8
  return createOverlayContainer(<Image src={`/assets/quanta/nftCollections/${icon}.png`} alt={icon} width={40} height={40} />);
};

const TaskCard: React.FC<TaskCardProps> = ({
  missionId,
  title,
  points,
  maxMultiplier,
  multiplier,
  completionDate,
  icon,
}: TaskCardProps) => {
  const formattedDate = format(new Date(completionDate), 'dd.MM.yyyy');

  return (
    <div className='flex items-center justify-between gap-8 px-4 py-3 rounded-lg border border-border-primary bg-[rgba(17, 16, 21, 0.50)]'>
      <div className='flex items-center gap-3'>
        {renderIcon(icon, missionId)}
        <div>
          <div className='flex items-center gap-2'>
            <p className='text-lg font-medium text-text-secondary'>{title}</p>
            <Multiplier isCompleted={true} hasX={false} maxMultiplier={maxMultiplier} multiplier={multiplier} />
          </div>
          <QuantaPoints points={points} />
        </div>
      </div>
      <div className='flex flex-col gap-0.5 items-end'>
        <CompletedMessage />
        <span className='text-lg font-medium text-text-secondary'>{formattedDate}</span>
      </div>
    </div>
  );
};

export default TaskCard;
